import translations from './OnboardingChart.translations'

export const STATS_STEPS = [0, 15, 30, 45, 60, 75, 90, 100]

export function getStatsBlockContent(tasksCompletionRate: number) {
  if (tasksCompletionRate === STATS_STEPS[0]) {
    return {
      title: translations.circleChartTitle1,
      description: translations.circleChartDescription1,
    }
  }
  if (
    tasksCompletionRate > STATS_STEPS[0] &&
    tasksCompletionRate <= STATS_STEPS[1]
  ) {
    return {
      title: translations.circleChartTitle2,
      description: translations.circleChartDescription2,
    }
  }
  if (
    tasksCompletionRate > STATS_STEPS[1] &&
    tasksCompletionRate <= STATS_STEPS[2]
  ) {
    return {
      title: translations.circleChartTitle3,
      description: translations.circleChartDescription3,
    }
  }
  if (
    tasksCompletionRate > STATS_STEPS[2] &&
    tasksCompletionRate <= STATS_STEPS[3]
  ) {
    return {
      title: translations.circleChartTitle4,
      description: translations.circleChartDescription4,
    }
  }
  if (
    tasksCompletionRate > STATS_STEPS[3] &&
    tasksCompletionRate <= STATS_STEPS[4]
  ) {
    return {
      title: translations.circleChartTitle5,
      description: translations.circleChartDescription5,
    }
  }
  if (
    tasksCompletionRate > STATS_STEPS[4] &&
    tasksCompletionRate <= STATS_STEPS[5]
  ) {
    return {
      title: translations.circleChartTitle6,
      description: translations.circleChartDescription6,
    }
  }
  if (
    tasksCompletionRate > STATS_STEPS[5] &&
    tasksCompletionRate <= STATS_STEPS[6]
  ) {
    return {
      title: translations.circleChartTitle7,
      description: translations.circleChartDescription7,
    }
  }

  return {
    title: translations.circleChartTitle8,
    description: translations.circleChartDescription8,
  }
}
